import API from 'my-core/api';
import normalizeJSON from 'my-core/normalizeJSON';
import standardApiRequestAction from 'my-core/standardApiRequestAction';

import types from '../constants/OnlineCourseActivityShareActionTypes';

export function fetchOnlineCourseActivityShare(token, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_activity_shares/${token}`,
    requestKey,
  });
}

export function createOnlineCourseActivityShare(activityId, createKey) {
  return dispatch => {
    dispatch({ type: types.CREATE_ONLINE_COURSE_ACTIVITY_SHARE, createKey });
    API.postJSON('/api/v1/online_course_activity_shares', { online_course_activity_id: activityId })
      .then(res => {
        const { onlineCourseActivityShares } = normalizeJSON(res);
        dispatch({ type: types.CREATE_ONLINE_COURSE_ACTIVITY_SHARE_SUCCESS, onlineCourseActivityShares, createKey });
      })
      .catch(error => {
        dispatch({ type: types.CREATE_ONLINE_COURSE_ACTIVITY_SHARE_FAIL, error, createKey });
      });
  };
}
